import { UseQueryOptions } from '@tanstack/react-query'

import { apiGet } from '../axios.config'
import { API_ROUTES } from '../routes'
import { useQueryHook } from './queryHook'

interface IResponse {
  result: boolean
}

export const useCheckStatusAuthor = (
  phone: string,
  options?: Omit<UseQueryOptions<IResponse>, 'queryKey' | 'queryFn'>,
) => {
  const path = API_ROUTES.AUTHORS_CHECK

  const queryObject = useQueryHook({
    key: [path, phone],
    fetcherFunction: async () => {
      const { data } = await apiGet<object, IResponse>({
        path,
        params: { phone },
      })

      return data
    },
    options,
  })

  if (queryObject.isLoading || queryObject.isError) {
    return {
      ...queryObject,
      data: null,
    }
  }

  return {
    ...queryObject,
    data: queryObject.data as IResponse | null,
  }
}
